import ContainerHead from "../molecules/ContainerHead";
import SwiperElement from "../molecules/SwiperElement";

class TopCategories {
  // Top Categories Swiper Parameters
  // 'slidesOffset*' seems to be a bit buggy, when entering different
  // breakpoint ranges, thus added the appropriate values to every bp
  private static swiperParams = {
    navigation: {
      nextEl: ".top-categories .swiper-btn-next",
      prevEl: ".top-categories .swiper-btn-prev",
    },
    lazyPreloadPrevNext: 3,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    slidesPerView: 2.5,
    breakpoints: {
      481: {
        lazyPreloadPrevNext: 3,
        slidesPerView: 3.2,
      },
      651: {
        lazyPreloadPrevNext: 4,
        slidesPerView: 3.8,
      },
      768: {
        lazyPreloadPrevNext: 5,
        slidesPerView: 4.5,
      },
      851: {
        lazyPreloadPrevNext: 5,
        slidesPerView: 4.5,
      },
      941: {
        lazyPreloadPrevNext: 6,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        slidesPerView: 5.5,
        rewind: true,
      },
      1132: {
        lazyPreloadPrevNext: 6,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 6,
        rewind: true,
      },
    },
  };

  public static run(section: HTMLElement): void {
    const containerHead: HTMLElement | null = section.querySelector(".react-container-head");
    if (containerHead) {
      new ContainerHead(containerHead);
    }

    const navigationButtons: HTMLElement | null = section.querySelector(".swiper-navigation");
    if (navigationButtons !== null) {
      navigationButtons.style.display = "";
    }

    SwiperElement.run(section, TopCategories.swiperParams);
  }
}

export default TopCategories;
